function hashSeed(salt) {
    let h = 2166136261;
    for (let i = 0; i < salt.length; i++) {
        h ^= salt.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}
function mulberry32(a) {
    return function () {
        let t = (a += 0x6d2b79f5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
function shuffle(arr, rng) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}
/** True when the NPC is placed inside `position_near_building` (not on the street). */
export function isNpcIndoor(npc) {
    return Boolean(npc.position_near_building?.trim());
}
/**
 * Deterministic ~50/50 indoor/outdoor split. Indoor NPCs get a unique building each;
 * outdoor NPCs have `position_near_building` cleared so they patrol the zone spine.
 */
export function applyDeterministicNpcIndoorOutdoorSplit(manifest, seedId) {
    const npcs = manifest.npcs ?? [];
    const buildings = manifest.buildings ?? [];
    if (npcs.length === 0 || buildings.length === 0)
        return;
    const indoorCount = Math.min(Math.max(1, Math.floor(npcs.length / 2)), buildings.length);
    const rng = mulberry32(hashSeed(`${seedId}|npc_indoor_outdoor`));
    const order = shuffle(npcs.map((n) => n.instance_id), rng);
    const byId = new Map(npcs.map((n) => [n.instance_id, n]));
    const usedBuildings = new Set();
    for (let i = 0; i < order.length; i++) {
        const n = byId.get(order[i]);
        if (i >= indoorCount) {
            n.position_near_building = null;
            continue;
        }
        const zonePool = buildings
            .map((b) => b.building_id)
            .filter((bid) => !usedBuildings.has(bid) && buildings.find((b) => b.building_id === bid)?.zone === n.zone);
        const anyPool = buildings
            .map((b) => b.building_id)
            .filter((bid) => !usedBuildings.has(bid));
        const pool = zonePool.length > 0 ? zonePool : anyPool;
        if (pool.length === 0) {
            n.position_near_building = null;
            continue;
        }
        const bid = pool[Math.floor(rng() * pool.length)];
        n.position_near_building = bid;
        usedBuildings.add(bid);
    }
}
